import { FAILURE, REQUEST, SUCCESS } from '../constants';

export function getRequestActionType(type) {
  return `${type}${REQUEST}`;
}

export function getSuccessActionType(type) {
  return `${type}${SUCCESS}`;
}

export function getFailureActionType(type) {
  return `${type}${FAILURE}`;
}
